module.exports = __webpack_public_path__ + "media/images/premium/help-circle-a5c74c4666585c4019916e2fd58cc7d6.svg";